import { ButtonIcon, EditIcon, Tooltip } from 'canoe';
import React from 'react';

import { useEventing } from 'commons/eventing';
import { useToolboxState } from 'craft/state';
import { ToolboxTabs } from 'craft/types';

export const ComponentButton = React.memo(() => {
  const { setDockedState, setTab } = useToolboxState();
  const { track } = useEventing();

  return (
    <Tooltip placement="top" offset="xxs" content="Component">
      <ButtonIcon
        size="small"
        icon={EditIcon}
        radius="small"
        color="white"
        onClick={() => {
          if (setDockedState(false)) {
            track('editor.dockedToolbox.open');
          }
          setTab(ToolboxTabs.Component);
        }}
      />
    </Tooltip>
  );
});
